import {
  useGlobalStoreActions,
  useGlobalStoreState,
} from '../../store/globalStore'

export const useIsSmallScreen = () => {
  const isSmallScreen = useGlobalStoreState(state => state.isSmallScreen)
  const initialiseIsSmallScreen = useGlobalStoreActions(
    actions => actions.setIsSmallScreen,
  )

  return {
    initialiseIsSmallScreen,
    isSmallScreen,
  }
}
